// Bootstrap: tworzy aplikacje i oddaje sterowanie orkiestratorowi (app/controller.ts).

import './styles.css';
import { App } from './app/controller';

new App();